import apiClient from './apiClient';

/**
 * Request a short-lived signed download token for a protected file under
 * /uploads and navigate the target window to it.
 *
 * The backend's /uploads gate accepts either an Authorization Bearer header
 * (not available to a plain navigation) or a `?token=` query param signed
 * for that exact path — this helper uses the latter so PDFs can be viewed
 * inline without leaking the user's JWT.
 *
 * `target` should be a window opened synchronously inside a user gesture
 * (e.g. `window.open('about:blank', '_blank')` at the start of the click
 * handler). Without that, popup blockers will swallow the result, because
 * generating the file + signing the token are async.
 */
export async function openSignedFile(filePath: string, target: Window): Promise<void> {
  try {
    // httpClient returns the response *body*; the /auth/file-token endpoint
    // responds with a flat { token } (no { data } envelope), so read it
    // robustly from either shape.
    const body = (await apiClient.post<{ token: string }>('/auth/file-token', { filePath })) as {
      token?: string;
      data?: { token?: string };
    };
    const token = body.token ?? body.data?.token;
    if (!token) throw new Error('Token de download não recebido');
    const separator = filePath.includes('?') ? '&' : '?';
    target.location.href = `${filePath}${separator}token=${encodeURIComponent(token)}`;
  } catch (err) {
    target.close();
    throw err;
  }
}
